import * as React from "react"
import "./styles.scss";

export default function PagePreload({ setSelectedDisplay }) {
    return (
        <div className="page-preload-wrapper">
            <div className="background-wrapper">
                <div className="image-background-layer" />

                <div className="logo-layer">
                    <div />
                    <i><img src="/static/images/dwa/dwa-logo.svg" alt="" /></i>
                    <div className="action-wrapper">
                        <button className="button-light"
                                onClick={() => setSelectedDisplay('passport')}
                        >
                            Product Passport
                        </button>
                        <button className="button-dark"
                                onClick={() => setSelectedDisplay('gift')}
                        >
                            Claim my gift
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
